import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy, faBriefcase, faLightbulb, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FacebookRounded, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import { faCheck, faMultiply } from "@fortawesome/free-solid-svg-icons";



export const nav = [
  {
    text: "home",
    path: "/",
  },
  {
    text: "about",
    path: "/about",
  },
  {
    text: "services",
    path: "/services",
  },
  {
    text: "blog",
    path: "/blog",
  },
  {
    text: "contact",
    path: "/contact",
  },
]
export const featured = [
  {
    cover: "../images/hero/h1.png",
    name: "Flats & House",
    total: "122 Property",
  },
  {
    cover: "../images/hero/h2.png",
    name: "Row houses",
    total: "155 Property",
  },
  {
    cover: "../images/hero/h3.png",
    name: "Apartment",
    total: "300 Property",
  },
  {
    cover: "../images/hero/h4.png",
    name: "Office & Showroom",
    total: "80 Property",
  },
  {
    cover: "../images/hero/h6.png",
    name: "plot & land",
    total: "80 Property",
  },
]
export const list = [
  {
    id: 1,
    cover: "../images/list/p-1.jpg",
    name: "Ekta Greenville  - 2 Bhk",
    location: "pathardi phata , Nashik",
    category: "For Rent",
    price: "Rs.12,000",
    type: "Apartment",
  },
  {
    id: 2,
    cover: "../images/list/p-2.jpg",
    name: "Shreeji Annex - 2 Bhk",
    location: "Pathardi Phata, Nashik",
    category: "For Rent",
    price: "Rs.10,000",
    type: "Apartment",
  },
  {
    id: 3,
    cover: "../images/list/p-7.jpg",
    name: "2bhk Apartment",
    location: "Indira Nagar, Nashik",
    category: "For Rent",
    price: "Rs.10,000",
    type: "Apartment",
  },
  {
    id: 4,
    cover: "../images/list/p-4.jpg",
    name: "2 bhk Row House",
    location: "indira Nagar, Nashik",
    category: "For Sale",
    price: "Rs.11,000",
    type: "Row House",
  },
  {
    id: 5,
    cover: "../images/list/p-5.jpg",
    name: "1 bhk apartment",
    location: "Damodar circle , patahrdi , nashik",
    category: "For Rent",
    price: "Rs.6,500",
    type: "Apartment",
  },
  {
    id: 6,
    cover: "../images/list/p-6.jpg",
    name: "2bhk Row House",
    location: "pathardi phata , Nashik",
    category: "For Rent",
    price: "Rs.11,000",
    type: "Apartment",
  },
]
export const awards = [
  {
    icon: <i class='fa-solid fa-trophy'><FontAwesomeIcon icon={faTrophy} /></i>,
    num: "32 M	",
    name: "Best Property Award",
  },
  {
    icon: <i class='fa-solid fa-briefcase'><FontAwesomeIcon icon={faBriefcase} /></i>,
    num: "43 M",
    name: "Real Estate Award",
  },
  {
    icon: <i class='fa-solid fa-lightbulb'><FontAwesomeIcon icon={faLightbulb} /></i>,
    num: "51 M",
    name: "Best Rental Award",
  },
  {
    icon: <i class='fa-solid fa-heart'><FontAwesomeIcon icon={faHeart} /></i>,
    num: "42 M",
    name: "City Rental Award",
  },
]
export const location = [
  {
    id: 1,
    name: "Chitwan, Nepal",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-1.jpg",
  },
  {
    id: 2,
    name: "Pokhara, Nepal",
    Villas: "12 Villas",
    Apartments: "10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-2.jpg",
  },
  {
    id: 3,
    name: "Illam, Nepal",
    Villas: "12 Villas",
    Apartments: " 10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-3.jpg",
  },
  {
    id: 4,
    name: "Biratnagar, Nepal",
    Villas: "12 Villas",
    Apartments: " 10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-4.jpg",
  },
  {
    id: 5,
    name: "Ithari, Nepal",
    Villas: "12 Villas",
    Apartments: " 10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-5.jpg",
  },
  {
    id: 6,
    name: "Kathmandu, Nepal",
    Villas: "12 Villas",
    Apartments: " 10 Apartments",
    Offices: "07 Offices",
    cover: "./images/location/city-6.jpg",
  },
]
export const team = [
  {
    list: "50",
    cover: "../images/customer/team-1.jpg",
    address: "Kathmandu, Nepal",
    name: "Anna K. Young",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
  {
    list: "70",
    cover: "../images/customer/team-2.jpg",
    address: "Jhapa, Nepal",
    name: "Anna K. Young",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
  {
    list: "80",
    cover: "../images/customer/team-3.jpg",
    address: "Kathmandu, Nepal",
    name: "Michael P. Grimaldo",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
  {
    list: "51",
    cover: "../images/customer/team-4.jpg",
    address: "Biratnagar, Nepal",
    name: "Michael P. Grimaldo",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
  {
    list: "42",
    cover: "../images/customer/team-5.jpg",
    address: "Dharan, Nepal",
    name: "Anna K. Young",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
  {
    list: "38",
    cover: "../images/customer/team-1.jpg",
    address: "Pokhara, Nepal",
    name: "Anna K. Young",
    icon: [<i class='fa-brands fa-facebook-f'><FacebookRounded /></i>, 
    <i class='fa-brands fa-linkedin'><LinkedIn/></i>, 
    <i class='fa-brands fa-twitter'><Instagram /></i>, 
    <i class='fa-brands fa-instagram'><Twitter /></i>],
  },
]
export const price = [
  {
    plan: "Basic",
    price: "499",
    ptext: "per user, per month",
    list: [
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "99.5% Uptime Guarantee",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "120GB CDN Bandwidth",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "5GB Cloud Storage",
      },
      { change: "color", icon: <i class='fa-solid fa-x'><FontAwesomeIcon icon={faMultiply} /></i>, 
      text: "Personal Help Support" },
      { change: "color", icon: <i class='fa-solid fa-x'><FontAwesomeIcon icon={faMultiply} /></i>, 
      text: "Enterprise SLA" },
    ],
  },
  {
    best: "Best Value",
    plan: "Standard",
    price: "699",
    ptext: "per user, per month",
    list: [
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "99.5% Uptime Guarantee",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "150GB CDN Bandwidth",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "10GB Cloud Storage",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "Personal Help Support",
      },
      {
        change: "color",
        icon: <i class='fa-solid fa-x'><FontAwesomeIcon icon={faMultiply} /></i>,
        text: "Enterprise SLA",
      },
    ],
  },
  {
    plan: "Platinum",
    price: "999",
    ptext: "2 user, per month",
    list: [
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "100% Uptime Guarantee",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "200GB CDN Bandwidth",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "20GB Cloud Storage",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "Personal Help Support",
      },
      {
        icon: <i class='fa-solid fa-check'><FontAwesomeIcon icon={faCheck} /></i>,
        text: "Enterprise SLA",
      },
    ],
  },
]
export const footer = [
  {
    title: "LAYOUTS",
    text: [{ list: "Home Page" }, { list: "About Page" }, { list: "Service Page" }, { list: "Property Page" }, { list: "Contact Page" }, { list: "Single Blog" }],
  },
  {
    title: "ALL SECTIONS",
    text: [{ list: "Headers" }, { list: "Features" }, { list: "Attractive" }, { list: "Testimonials" }, { list: "Videos" }, { list: "Footers" }],
  },
  {
    title: "COMPANY",
    text: [{ list: "About" }, { list: "Blog" }, { list: "Pricing" }, { list: "Affiliate" }, { list: "Login" }, { list: "Changelog" }],
  },
]